module.exports = __webpack_public_path__ + "static/media/mastCellTumor.9d61cda9.jpg";